/**
 * Шеврон раскрытия строки списка.
 *
 * Одна механика на всё приложение (SPEC, «Строка списка и таблица»). До
 * 14.09.2026 деталь строки открывалась четырьмя разными способами на четырёх
 * экранах: аккордеоном на месте, блоком под кнопкой, модальным окном и
 * переходом на страницу. Остался аккордеон; переход на страницу оставлен там,
 * где у детали есть свой адрес, и такое место в продукте одно, карточка
 * ученика.
 *
 * ⚠️ **Слово со строки не исчезло, оно переехало в подпись кнопки.** Там, где
 * раньше стояла кнопка «Изменить», теперь шеврон, и читалка называет ровно то же
 * слово. Это то же правило, по которому значок заменил слово в ячейке действий
 * списка уроков: фигура говорит то же, что слово, а место экономит.
 *
 * ⚠️ **Подписи ДВЕ, и это не дубль.** Читалке достаётся действие вместе с тем, к
 * кому оно относится: в списке из тридцати строк одинаковая подпись без имени
 * это тридцать одинаковых кнопок, и это уже было причиной правки у «Новой
 * ссылки» и «Изменить». А всплывающей подсказке достаётся одно действие, без
 * имени: имя стоит в той же строке в сантиметре правее, и повторять его значит
 * показывать пальцем на соседа.
 *
 * Фигура своя, а не из `features/shell/icons.tsx`: там значки разделов и
 * действий, у каждого своя подпись и свой смысл, а это часть КОНТРОЛА, у
 * которой смысла в отрыве от кнопки нет. Поворот на 90 градусов делает CSS по
 * `aria-expanded`, чтобы фигура была одна, а не две.
 */
export function RowDisclosure(props: {
  open: boolean;
  /** Что случится по нажатию: «Изменить день», «Ещё действия». */
  action: string;
  /** К кому это относится: имя ученика, название заготовки, день недели. */
  subject: string;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      className="row__x"
      aria-expanded={props.open}
      aria-label={`${props.action}: ${props.subject}`}
      title={props.action}
      onClick={props.onToggle}
    >
      <ChevronIcon />
    </button>
  );
}

/**
 * Шеврон, сетка 24, обводка 1.5, без заливки: правила значков системы. Пустой
 * для читалок, подпись живёт на кнопке.
 *
 * ⚠️ **Сторон две с 17.09.2026, и вторая приехала не ради красоты.** Полоса
 * управления расписанием заменила слова «Раньше» и «Позже» шевронами (правило
 * «значок вместо слова там, где фигура говорит то же»), и левый ей нужен такой
 * же, как правый, а не повёрнутый правилом в чужом файле. Умолчание «вправо»,
 * потому что раскрытие строки списка это три четверти употреблений и менять их
 * разметку незачем.
 *
 * Своей фигуры расписание при этом НЕ заводит: два шеврона в продукте это два
 * прочтения одной формы, и разойтись они успевают до первой правки.
 */
export function ChevronIcon(props: { direction?: "left" | "right" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={props.direction === "left" ? "M15 6l-6 6 6 6" : "M9 6l6 6-6 6"} />
    </svg>
  );
}
